<template>
    <rkm-form ref="RkmForm">
        <rkm-overlay :show="loading">
            <rkm-tabs>
                <rkm-tab title="Manual">
                    <rkm-form-text-editor
                        name="manual"
                        v-model="model.manual"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-funcionalidade-form')
        },
        validations() {
            return {}
        },
    },
    data: () => ({
        model: {
            sistema_nome: null,
            modulo_nome: null,
            funcionalidade_nome: null,
            funcionalidade_identificador: null,
            manual: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-funcionalidade-form')

                this.repositories.cadastro.funcionalidade.edit(this.id)
                    .then(({data}) => this.model = data.model)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-funcionalidade-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-funcionalidade-form')

                        const request = {
                            manual: this.model.manual
                        }

                        this.repositories.cadastro.funcionalidade.update(request, this.id)
                            .then(({data}) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('cadastro-funcionalidade-form'))
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>